import { Api } from "./api"

export class AbTestApi extends Api {
  constructor() {
    super('ab_tests', ['cuppingSessionId', 'nps','descriptor', 'other'])
  }
}
